import { useAction, useAtom } from '@reatom/npm-react'
import styled from 'styled-components'

import {
  CustomThemeForm,
  type BaseThemeOption,
} from '@root/entities/theme/ui/custom-theme/custom-theme-form'
import { useTranslation } from '@root/shared/localization'
import {
  availableThemes,
  currentCustomThemeAtom,
  currentCustomUiThemeAtom,
  currentThemeIdAtom,
  patchCustomThemeColorsAction,
  setCustomAppearanceAction,
  setCustomAppearanceColorAction,
  setCustomBaseThemeAction,
  ThemeId,
} from '@root/shared/theme'

import type { TransKey } from '@root/shared/localization'

const ID_TITLE_MAP: Record<ThemeId, TransKey> = {
  [ThemeId.Deluge]: 'theme.deluge.name',
  [ThemeId.DelugeLight]: 'theme.delugeLight.name',
  [ThemeId.Test]: 'theme.test.name',
  [ThemeId.Photgone]: 'theme.photgone.name',
  [ThemeId.Monokai]: 'theme.monokai.name',
}

export const SettingsAppSettingsCustomTheme = () => {
  const { t } = useTranslation()
  const [customTheme] = useAtom(currentCustomThemeAtom)
  const [customUiTheme] = useAtom(currentCustomUiThemeAtom)
  const [, setActiveThemeId] = useAtom(currentThemeIdAtom)
  const patchColors = useAction(patchCustomThemeColorsAction)
  const setBaseTheme = useAction(setCustomBaseThemeAction)
  const setAppearance = useAction(setCustomAppearanceAction)
  const setAppearanceColor = useAction(setCustomAppearanceColorAction)

  const baseThemeOptions: ReadonlyArray<BaseThemeOption> = availableThemes.map(
    (theme) => ({
      id: theme.id,
      label: t(ID_TITLE_MAP[theme.id]),
    }),
  )

  return (
    <Root>
      <CustomThemeForm
        customTheme={customTheme}
        baseThemeOptions={baseThemeOptions}
        previewTheme={customUiTheme}
        onAppearanceChange={(appearance) => {
          setAppearance(appearance)
          setActiveThemeId('custom')
        }}
        onAppearanceColorChange={(appearanceColor) => {
          setAppearanceColor(appearanceColor)
          setActiveThemeId('custom')
        }}
        onBaseThemeChange={(baseTheme) => {
          setBaseTheme(baseTheme)
          setActiveThemeId('custom')
        }}
        onChange={(colors) => {
          patchColors(colors)
          setActiveThemeId('custom')
        }}
        onSubmit={() => {}}
      />
    </Root>
  )
}

const Root = styled.div`
  padding: 12px;
`
